export const TRANSLATIONS_ZH_HK = {
  leftNavigation: {
    dashboard: "儀表板",
    sessions: "課程內容",
    teams: "團隊",
    profile: "個人檔案",
    logs: "日誌",
    warningLetters: "警告信",
    settings: "設定",
    userManagement: "用戶管理",
    subjectManagement: "主題管理",
    changePassword: "更改密碼",
    helpAndSupport: "幫助及支援",
    scoresheet: "Scoresheet",
  },
  header: {
    logout: "登出",
    notifications: "通知",
    loadingNotifications: "Loading 通知....",
    stepper: {
      plan: "計劃",
      do: "進行",
      check: "檢查",
      act: "行動",
    },
  },
  tabs: {
    ceo: "行政總裁",
    executive: "管理层",
    coe: "卓越中心",
    campaign: "Functional Unit", //functional unit text
    team: "團隊",
    personal: "Personal",
  },
  notification: {
    session: "您在 ",
    on: "與{姓名}有一個教練課程。請在 ",
    checkpointUpdated: "更新了檢查點日期",
    complete: "之前完成GROW Model 。",
    growmodel: "已完成GROW Model 並接受了您的邀請",
    progression: "已更新您的進度 ",
    compliment: "讚揚了您",
    rating: "之前對您與的指導課程進行評分",
    review: "已將您的最終審查日期更改為",
    archivedSession: "已對指導課程進行評分並存檔!",
    checkpoint: "檢查點",
    updateFor: "的檢查點",
    isAvailable: "更新可用",
    at: "您天在",
    today: "今",
    youHaveYetToSetCheckPoint: "您尚未為設置檢查點",
    by: "請在",
    youHaveAReviewSessionWith: "您今天在與進行了審查",
    youHaveUpcomingSession: "您即將與進行指導課程",
    youHaveCompleted: "您在上個月完成了",
    sessionCompletedLastMonth: "個課程",
  },
  dashboard: {
    title: "儀表板",
    noDataYet: "尚未有數據",
    tabs: {
      ceo: "行政總裁",
      executive: "管理人員",
      coe: "卓越中心",
      campaign: "Functional Unit",
      team: "團隊",
      personal: "Personal",
    },
    coachingSessionWith: "指導課程",
    checkpointSetupFor: "檢查點設置為",
    checkpointUpdateFor: "檢查點更新為",
    reviewSessionWith: "審查課程與",
    average: "平均數",
    longest: "最長的",
    shortest: "最短的",
    executive: {
      sessionClosed: "已關閉課程",
      overall: "整體",
      totalInprogress: "Total in progress",
      avgUsageRate: "Avg usage rate",
      usageRate: "Usage rate",
      totalSessionClosed: "已關閉課程總數",
      totalCoachees: "總學員數目",
      avgSessionClosed: "已關閉課程平均數",
      coachingHours: "指導時間",
      totalCoachingHours: "總指導時數",
      avgCoachingHours: "平均指導時數",
      totalPlanDuration: "計劃總持續時間",
      totalDoDuration: "進行總持續時間",
      totalCheckDuration: "檢查總持續時間",
      totalActDuration: "行動總持續時間",
      coachingSubjects: "指導主題",
    },
    coach: {
      dashboard: "儀表板",
      report: "報告",
      upcomingTask: "即將到來的任務",
      overdueTask: "逾期任務",
      recentTask: "近期活動",
      top3coaches: "排名前三的培訓",
      campaignSession: "活動課程內容",
      totalCoach: "總學員數目",
      coached2OrMoreSession: "指導了兩次或以上課程",
      coached1Session: "指導了一次課程",
      notCoachedYet: "尚未指導",
      showResultFor: "顯示結果",
      happiness: "幸福",
      complimentLikes: "讚揚點讚",
      success: "成就",
      ratedSession: "課程評級",
      totalSession: "課程總數",
      likes: "點讚",
      totalComplements: "補充總數",
      passRate: "合格率",
      totalSubjects: "主題總數",
      comparedTo: "對比",
      mostCoachedSubjects: "大部分已指導主題",
      average: "平均數",
      mostFailedSubjects: "大部分不合格主題",
      topSkillsToImprove: "首要改進的技能",
      teamAverage: "團隊平均數",
      coach: "指導",
      typeOfSession: "課程類型",
      subjects: "主題",
      session: "課程",
      sessionDuration: "課程持續時間",
      length: "長度",
      minutes: "分鐘",
      longest: "最長的",
      shortest: "最短的",
      plan: "計劃",
      do: "進行",
      check: "檢查",
      act: "行動",
      total: "總數",
      individual: "個別",
      metricsHead: "團隊成員的指導課程",
      complianceRate: "達標率",
      incompleteRate: "未完成率",
      conditionalPassRate: "條件合格率",
      campaign: "Functional Unit",
      sessions: "課程",
      manual: "指南",
      expired: "已到期",
      team: "團隊",
      campaignAverage: "活動平均數",
      topCountries: "熱門國家",
    },
    personal: {
      dashboard: "儀表板",
      showResultFor: "顯示結果",
      happiness: "幸福指數",
      complimentLikes: "讚揚點讚",
      success: "成就",
      ratedSession: "課程評級",
      totalSession: "課程總數",
      likes: "點讚",
      totalComplements: "補充總數",
      passRate: "合格率",
      totalSubjects: "主題總數",
      latestCompliments: "最新讚揚",
      comparedToTeamAvg: "比較團隊平均數",
      mostCoachedSubjects: "大部分已指導主題",
      mostFailedSubjects: "大部分不合格主題",
      topSkillsToImprove: "首要改進的技能",
      individual: "個別",
      teamAverage: "團隊平均數",
      subjects: "主题",
      session: "辅导",
    },
    selectReport: "選擇報告",
    overallCoachingSessionsReport: "整體指導課程報告",
    sessionDiscussionReport: "課程討論報告",
    monthly: "每月",
    custom: "自訂",
    cancel: "取消",
    download: "下載",
  },
  sessionList: {
    title: "辅导",
    totalSessionPending: "待處理的課程總數",
    allCoaches: "所有指導員",
    allStatus: "所有狀態",
    upcomingSession: "即將舉行的課程",
    sessionDateTime: "Session Date",
    time: "時間",
    type: "類型",
    subjects: "主題",
    coach: "指導員",
    coachee: "學員",
    status: "狀態",
    createSession: "建立課程",
    allCountries: "所有國家",
    allCampaign: "所有活動",
    sessionSuccess: "課程完滿結束",
    name: "名称",
  },
  createSession: {
    backToSession: "返回課程",
    createNewSession: "建立新課程",
    campaign: "Functional Unit",
    coachee: "學員",
    coach: "指導員",
    assignToOtherCoach: "指派給其他指導員",
    assignTo: "指派給",
    selectTeamMember: "選擇團隊成員",
    viewCoacheesStates: "檢閲學員歷史紀錄",
    coachingDate: "培訓日期",
    method: "方法",
    framework: "框架",
    reviewDate: "審查日期",
    typeOfSession: "課程類型",
    addSubjects: "增加主題",
    sessionNotes: "課程摘要",
    keyPoint: "重點",
    addNewNote: "增加新註釋",
    compliment: "讚揚",
    casualNote: "隨手註釋",
    createSendInvitation: "建立或發送邀請",
    assignFieldMandatory: "分配領域是強制性的",
    coacheeFieldMandatory: "學員領域是強制性的",
    logs: "日誌",
    complettionDate: "完成日期",
    duration: "持續時間",
    type: "類型",
    subjects: "主題",
    name: "名稱",
    status: "狀態",
    noTeamLogsFound: "未能尋找團隊日誌",
    close: "關閉",
    methodIsMandatory: "方法是強制性的",
    frameworkIsMandatory: "框架是強制性的",
    sessionTypeIsMandatory: "課程類型是強制性的",
    pleaseAddAtLeastOneSubject: "請增加至少一個主題",
    selectAcoach: "選擇指導員",
    ErrorNetworkError: "错误:錯誤：網絡錯誤",
    notes: "笔记",
  },
  sessionDetails: {
    backtosession: "返回課程",
    sessionDetails: "課程詳情",
    coach: "指導員",
    coachee: "學員",
    caochingDate: "指導日期",
    reviewDate: "審查日期",
    typeofSession: "課程類型",
    subjects: "主題",
    gentleReminderTitle: "温馨提醒",
    gentleReminder: "溫馨提示：在開始準備課程之前，請閱讀右側面板上的要點。",
    startPreparation: "開始準備",
  },
  growForm: {
    planSessionBasedonGrowModel: "根據GROW模式計劃課程",
    yourReviewSessionIsOn: "您的課程審查正在進行中",
    goals: "目的",
    comment: "評論",
    knowingYourCoachingSubjectsAndCreate:
      "了解您的培訓對象及制定計劃。利用 SMART Goals，在審查日期前達到目標。",
    SMARTGolasIsAnEstablished:
      "SMART Goals 是一種規劃和實現目標的既定方式。創建SMART Goals 有助於實現你想要完成的目標，如何實現你的目標，你的目標是否可以完成且相關，以及你希望何時完成你的目標。",
    reality: "現況",
    current: "目前情况",
    target: "目標",
    enterMetrics: "輸入指標",
    knowingYourCurrentPerformance: "了解您當前與培訓科目相關的表現",
    options: "選項",
    brainstormForMultipleOptionsToImprove:
      "集思廣益，提出多種方案，以改善培訓主題以達成目標。列舉可能的技術可以幫助密切範圍的機會。這個階段鼓勵創造性以探索可行的解決方案。",
    wayForward: "前進方向",
    selectTheMostFeasibleOptions: "選擇最可行的選項以成功實現目標",
    saveAndConfirmSession: "保存並確認課程",
    startCoachingSession: "開始培訓課程",
    edit: "編輯",
    startCoaching: "開始課程",
    proceedToSummary: "進入摘要",
    skillToImprove: "改進技能",
    selectSkill: "選擇技能",
    pleaseSelectSkillsToImprove: "請選擇需改進之技能",
    enterProjectKpi: "Enter Project Target KPI",
    projectTargetKpi: "Project Target KPI",
  },
  coachingSummary: {
    coachingSummary: "課程摘要",
    coach: "指導員",
    coachee: "學員",
    coachingDate: "課程日期",
    method: "方法",
    typeOfSession: "課程類型",
    goals: "目的",
    reality: "實際情况",
    current: "目前情况",
    target: "目標",
    skillToImprove: "改進技能",
    options: "選項",
    wayForward: "前進方向",
    yourReviewSessionWillBe: "您的課程將進行審查進",
    progressionCheckpoints:
      "進度檢查將由您的指導員在您的審核日期之前設置和更新",
    acknowledgement: "審閱",
    enterPassword: "輸入密碼",
    pleaseEnterPassword: "請輸入您的密碼",
    endCoaching: "結束課程",
    byAcknowledgingthisGrow:
      "確認此 GROW 表格，即表示您同意按照所述行動計劃開展工作",
    cancel: "取消",
    agree: "同意",
  },
  setCheckpoint: {
    backToSession: "返回課程",
    setCheckpoint: "設置檢查點",
    viewSessionSummary: "查看課程摘要",
    rateCoacheesBehaviour: "對學員的行為進行評分",
    checkpoint: "檢查點",
    addCheckpoint: "增加檢查點",
    reviewDate: "審查日期",
    gentleReminder:
      "溫馨提示：在確認評分和檢查點後，您將無法更改學員的行為評分",
    pleaseRateTheCoachees: "請對學員的行為進行評分",
    confirmRatingAndCheckpoints: "確認評分及檢查點",
  },
  sessionSummary: {
    viewSessionSummary: "查看課程摘要",
    coach: "辅导员",
    coachee: "被辅导者",
    coachingDate: "指導日期",
    method: "方法",
    typeOfSession: "課程類型",
    goals: "目的",
    reality: "實際情况",
    current: "目前情况",
    target: "目标",
    skillsToImprove: "要提高的技能",
    options: "選項",
    wayForward: "前進方向",
  },
  updateCheckpoint: {
    updateCheckpoint: "更新檢查點分數",
    edit: "編輯",
    viewSessionSummary: "查看課程摘要",
    reviewDate: "審查日期",
    checkpoint: "檢查點",
    final: "最終",
    previous: "過去的",
    checkpointProgressScore: "檢查點進度分數已成功保存",
    saveProgress: "保存進度分數",
    startReviewSession: "開始審查課程",
    postPoneReviewSession: "延遲審查課程",
    postPoneReviewSessionTo: "延遲審查課程至",
    pleaseStateReason: "請列明原因",
    cancel: "取消",
    schedule: "日程",
  },
  reviewSession: {
    reviewSession: "審查課程",
    finalReview: "最後審查",
    final: "最終",
    summary: "摘要",
    proceedToSummary: "進入摘要",
    summaryFieldIsRequired: "摘要必需填寫",
    sessionReviewSummarySavedSuccessfully: "課程審查摘要保存成功!",
    endReviewSession: "結束審查摘要",
    done: "完畢..！",
  },
  archiveSession: {
    backtoSession: "返回課程",
    backToLog: "Back to Logs",
    archiveSession: "存檔課程",
    areYouSatisfied: "您對本課程滿意嗎？",
    pleaseReadTHeSessionSummary:
      "請仔細閱讀課程摘要和注意事項。此課程存檔後，您將無法再“點讚”讚揚記錄。",
    totalDuration: "持續時間總數",
    durationBreakdown: "持續時間分類",
    viewReviewSessionSummary: "查看回顧課程摘要",
    coacheesBehaviour: "學員的行為",
    reviewDate: "審查日期",
    finalReview: "最終審查",
    summary: "摘要",
    notes: "記錄",
    selectYourFeedback: "選擇您的反饋",
  },
  personalProfile: {
    fullName: "全名",
    employeeID: "員工編號",
    campaign: "Functional Unit",
    market: "市場",
    designation: "指定",
    coach: "指導員",
    viewSession: "查看課程",
    viewLogs: "查看日誌",
    personalProfile: "個人檔案",
  },
  teams: {
    coach: "指導員",
    taggedCoaches: "已標記的學員",
    untaggedCoachees: "未標記的學員",
    searchFilter: "搜索篩選",
    employeeId: "員工編號",
    Campaign: "Functional Unit",
    department: "部門",
    subunit: "亚基",
    lastSession: "最後的課程",
    upcommingSession: "即將舉行的課程",
    totalCoachees: "學員總數",
    members: "會員",
    coaches: "指導員",
    allCountries: "所有國家",
    allCampign: "所有活動",
    teams: "團隊",
    name: "名称",
  },
  logs: {
    allCoaches: "所有指導員",
    searchFilter: "搜索篩選",
    completionDate: "完成日期",
    duration: "持續時間",
    subjects: "主題",
    coach: "指導員",
    coachee: "學員",
    status: "狀態",
    totalLogs: "日誌總數",
    type: "Type",
    averageDuration: "平均持續時間 (分鐘)",
    longestDuration: "最長持續時間 (分鐘)",
    shortestDuration: "最短持續時間 (分鐘)",
    filter: "篩選",
    names: "名稱",
    name: "姓名",
    clearAll: "清除所有",
    allCountries: "所有國家",
    AllCampaign: "所有活動",
  },
  userManagement: {
    searchFilter: "搜索篩選",
    name: "名稱",
    id: "ID",
    campaign: "Functional Unit",
    department: "部門",
    country: "國家",
    designation: "指定",
    role: "角色",
    status: "狀態",
    editUser: "編輯用戶",
    fullName: "全名",
    employeeID: "僱員ID",
    adminRole: "管理員角色",
    managerCoache: "管理學員",
    AddCoach: "增加指導員",
    userStatus: "用戶狀態",
    resetPassword: "重置密碼",
    saveChanges: "儲存變更",
    cancel: "取消",
    add: "增加",
    userDetailsUp: "用戶詳細信息更新成功",
    pleaseSaveToResetThe: "請保存以重置密碼",
  },
  subjectManagement: {
    searchFilter: "搜索篩選",
    campaign: "Functional Unit",
    department: "部門",
    lastEdited: "最後編輯",
    date: "日期",
    subjectFor: "主題為",
    status: "狀態",
    country: "國家",
    coachingCategory: "指導類別",
    subCategory: "子類別",
    dataType: "數據類型",
    conditionToPass: "通過條件",
    framework: "框架",
    enterSubCategory: "輸入子類別",
    selectType: "選擇類型",
    selectCondition: "選擇條件通",
    selectFramework: "選擇框架",
    addSubCategory: "增加子類別",
    skillToImprove: "改進技能",
    enterSkillToImprove: "輸入改進技能",
    addLevel: "增加級別",
    addSkillToImprove: "增加改進技能",
    actionAtCheckpoint: "檢查點行動",
    enterAction: "輸入行動",
    addAction: "增加行動",
    saveChanges: "儲存變更",
    cancel: "取消",
    editSubject: "編輯主題",
    subjectDetails: "主題詳細信息已更新",
    noRecordFound: "沒有找到記錄",
    somethingWentWrong: "發生錯誤。請稍後再試..！",
    functionalUnit: "Sub Functional Unit",
  },
  changePassword: {
    enterYourCurrentPassowrd: "輸入當前密碼",
    chooseAStrongPassword: "選擇一個強大密碼，並不要於其他帳戶重複使用",
    newPassword: "新密碼",
    passwordStrength: "密碼強度",
    useAtLeast12Charecters:
      "至少使用 12 個字符。不要使用其他網站的密碼，或太明顯的東西",
    confirmNewPassword: "確認新密碼",
    changePassword: "更改密碼",
    thePasswordDoNotMatch: "密碼不符!",
    passwordMustBeAtLeast12:
      "密碼必須至少12個字符，一個數字，一個特殊字符和一個大寫字母",
    passwordCannotBeSameAsOldPassword: "New password cannot be same as old password",
  },
  error: {
    loginerror: "用戶名稱或密碼錯誤",
    usererror: "用戶未啟動",
    internalServerError: "something went wrong, please try again",
    networkerror: {
      500: "Something went wrong",
    },
    paramerror: "“+屬性+”的值不能為空",
    passwordvalidationerror:
      "密碼必須至少10個字符，一個數字，一個特殊字符和一個大寫字母",
    newpasswordvalidationerror: "新密碼與確認不符",
    oldpasswordvalidationerror: "舊密碼不符",
    successpasswordvalidationerror: "密碼修改成功",

    noSessionDetailsFound: "未找到課程詳細信息",
    verbalWarningIssued: "發出口頭警告",
    verbalWarningIssueFailed: "未能發出口頭警告，請重試",
    alreadyTwoVerbalWarningIssued: "已經發出2次口頭警告，請嘗試其他方式",
    checkpointProgressScoreHasBeenSavedSuccessfully: "檢查點進度分數已成功保存",
    updatedCheckpointsSuccessfully: "成功更新檢查點",
    sessionReviewSummaryHasBeenSavedSuccessfully: "課程回顧摘要已成功保存",
    selectedCoachIsAlreadyInTheList: "所選指導員已在列表中",
    somethingWentWrongPleaseTryAgain: "發生錯誤，請重試",
    couldNotGetSession: "無法獲取課程",
    selectedCoacheeIsAlreadyBeenAdded: "已添加選定的學員",
    selectedCountryIsAlreadyInTheList: "所選國家/地區已在列表中",
    canNotUpdateActionAtCheckPoint: "無法在檢查點更新操作！",
    couldNotGetCountryList: "無法獲取國家列表",
    couldNotGetNotification: "無法收到通知",
    errorGettingReviewDateSummary: "獲取審查日期摘要時出錯",
    pleaseSelectCoachee: "請選擇學員",
    couldNotGetGrowFormDetailsFromSessionId:
      "無法從課程 ID 獲取增長表單詳細信息",
    pleaseSelectSubjectAndAddMetrics: "請選擇主題並添加指標",
    couldNotGetSkillsListBasedOnSubjectId: "無法根據主題 ID 獲取技能列表",
  },
  editSessionCoachingDates: {
    title: "Postpone Session Dates",
    update: "Update",
  },
  common: {
    noRecordFound: "沒有找到記錄",
    backToSession: "返回課程",
  },
};
